module.exports = __webpack_public_path__ + "assets/tutorial_mission_04.2d8a08d3.svg";